import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import { buildCartUrl } from '#client/utils/urls';

const StyledPaperRoot = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2, 2, 5)
  }
}));

const StyledGridContainer = styled(Grid)(({ theme }) => ({
  height: '100%',
  width: '100%',
  maxWidth: '100%',
  '& img': {
    width: '100%',
    maxWidth: theme.spacing(73),
    height: 'unset',
    margin: `5% ${theme.spacing(0, 5, 0)}`
  },
  '& h3': {
    marginBottom: theme.spacing(3)
  },
  '& p': {
    maxWidth: theme.spacing(64)
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

const DomainUpsell = ({ businessEntityUuid }) => {
  const domainsUrl = buildCartUrl('domain_name_reg', { businessEntityUuid });
  const trackClick = useLinkPressedCallback({
    elementName: 'no_domains_card',
    pageCategory: 'dashboard',
    pageSection: 'growth'
  });
  return (
    <>
      <Title level={3} variant="sm" align="center" gutterBottom>You don&apos;t have any domains yet.</Title>
      <StyledButton
        size="large"
        variant="contained"
        color="primary"
        href={domainsUrl}
        onClick={trackClick}
      >
        FIND DOMAIN NAMES
      </StyledButton>
      <Text size="sm" color="focus40" align="center">
        Please note that we do not accept domain transfers
        at this time.
      </Text>
    </>
  );
};

DomainUpsell.propTypes = {
  businessEntityUuid: PropTypes.string.isRequired
};

const NoDomainsCard = ({ businessEntityUuid }) => (
  <StyledPaperRoot data-testid="noDomainsCard">
    <StyledGridContainer
      container
      direction="column"
      alignItems="center"
    >
      <SharedAsset src="/icon/misc/domain_empty600.svg" width={489} alt="" />
      <Grid
        item
        container
        direction="column"
        alignItems="center"
      >
        <DomainUpsell businessEntityUuid={businessEntityUuid} />
      </Grid>
    </StyledGridContainer>
  </StyledPaperRoot>
);

NoDomainsCard.propTypes = {
  businessEntityUuid: PropTypes.string.isRequired
};

export default NoDomainsCard;
